// @flow
export const TRIP_INFORMATION_SET_KIDS = 'TRIP_INFORMATION_UPDATE_KIDS';
export const TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS =
  'TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS';
export const TRIP_INFORMATION_UPDATE_KID = 'TRIP_INFORMATION_UPDATE_KID';
export const TRIP_INFORMATION_RESET_KIDS = 'TRIP_INFORMATION_RESET_KID';

export const DEFAULT_KID_VALUE = {
  birthdate: undefined,
  neolid: undefined,
  childcareIncluded: true,
};

export const VALIDATION_STATE_ENUM = Object.freeze({
  valid: 'IS_VALID',
  invalid: 'IS_INVALID',
  notvalidated: 'NOT_VALIDATED',
});
export type ValidationState = $Values<typeof VALIDATION_STATE_ENUM>;
